﻿import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

import { Modal, Button } from "react-bootstrap";

import classes from "../../maintainers.module.scss";

import api from "@/services/api.service";
import Fetching from "@/components/Fetching/Fetching";

import ApplicationsFields from "./ApplicationsFields";
import { hasPermission } from "@/services/Utils";

const ApplicationsForm = ({ confirmSave, permissions }) => {
	const { addToast } = useToasts();
	const location = useLocation();
	const { action, application_history_id } = useParams();
	const navigate = useNavigate();

	const [isFetching, setIsFetching] = useState(true);
	const [application, setApplication] = useState({});

	const [estatesParents, setEstatesParents] = useState([]);
	const [estates, setEstates] = useState([]);
	const [categories, setCategories] = useState([]);
	const [species, setSpecies] = useState([]);
	const [varieties, setVarieties] = useState([]);
	const [quarters, setQuarters] = useState([]);
	const [businessCenter, setBusinessCenter] = useState([]);
	const [operators, setOperators] = useState([]);
	const [hauliers, setHauliers] = useState([]);

	const handleClose = () => {
		emptyFields();
		if (location.state) {
			navigate(location.state);
			return;
		}

		navigate("/mantenedores/aplicaciones");
	};

	const handleSave = () => {
		if (application.empty_container && application.not_used) {
			addToast("No es posible guardar la aplicación como envase vacío y no utilizado.", {
				appearance: "error",
			});
			return;
		}

		confirmSave(
			{
				application,
			},
			setIsFetching,
			afterSave,
		);
	};

	const emptyFields = () => {
		setApplication({});
		setEstates([]);
		setCategories([]);
		setSpecies([]);
		setVarieties([]);
		setQuarters([]);
		setBusinessCenter([]);
		setOperators([]);
	};

	const afterSave = (isCorrect) => {
		if (isCorrect) {
			handleClose();
			addToast("Aplicación guardada correctamente.", {
				appearance: "success",
			});
		}

		setIsFetching(false);
	};

	useEffect(() => {
		if (action && application_history_id && action === "editar") {
			setIsFetching(true);

			api.get("/admin/applications/detail", { application_id: application_history_id }).then((response) => {
				if (Object.prototype.hasOwnProperty.call(response, "application")) {
					setApplication({ ...response.application });
					setEstatesParents(response.estates_parents);
					setEstates(response.estates);
					setCategories(response.categories);
					setSpecies(response.species);
					setVarieties(response.varieties);
					setQuarters(response.quarters);
					setBusinessCenter(response.business_center);
					setOperators(response.operators);
					setHauliers(response.hauliers);
				} else {
					const newUrl = new URL(window.location.href);

					let newPathname = newUrl.pathname;
					const splitPathname = newUrl.pathname.split("/editar");
					if (splitPathname.length > 1) {
						newPathname = newUrl.pathname.split("/editar")[0];
					}

					navigate(newPathname);
				}

				setIsFetching(false);
			});
		}
		// eslint-disable-next-line
	}, [application_history_id, action]);

	return (
		<Modal
			show={action && action === "editar" ? true : false}
			onHide={handleClose}
			backdrop="static"
			keyboard={false}
			className={classes.main_form}
			size="lg"
		>
			<Modal.Header closeButton>
				<h4 className={classes.modal_title}>Aplicación</h4>
			</Modal.Header>

			<Modal.Body>
				{isFetching ? (
					<Fetching topMargin={"1em"} />
				) : (
					<ApplicationsFields
						application={application}
						estatesParents={estatesParents}
						estates={estates}
						categories={categories}
						species={species}
						varieties={varieties}
						quarters={quarters}
						businessCenter={businessCenter}
						operators={operators}
						hauliers={hauliers}
						setApplication={setApplication}
					/>
				)}
			</Modal.Body>
			<Modal.Footer>
				{hasPermission("edit", permissions) && !isFetching && (
					<Button variant="success" onClick={handleSave}>
						GUARDAR
					</Button>
				)}
			</Modal.Footer>
		</Modal>
	);
};

export default ApplicationsForm;
